import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  isLoading: true,
  isSuccess: false,
  isError: false,
  updateProductStatus: "",
  updateProductError: "",
  productDetails: [],
  message: "",
  response: {},
};

export const getProductDetails = createAsyncThunk(
  "products/getProductDetails",
  async (productId, thunkAPI) => {
    console.log(thunkAPI.getState());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/product/getproduct_details_with_mult_img/${productId}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/update_product",
  async (productDetail, { rejectWithValue }) => {
    const {
      id,
      isWeightVariable,
      otherProductInfo,
      productAmount,
      productBenefits,
      productBrand,
      productCategory,
      productDescription,
      productDiscountPercentage,
      productDiscountPrice,
      productImage,
      productTag,
      productName,
      storageAndUsage,
      productType,
      productSlug,
    } = productDetail;

    console.log("details", productDetail);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("product_name", productName);
    formData.append("product_amount", productAmount);
    formData.append("product_discount_price", productDiscountPrice);
    formData.append("category_id", productCategory);
    formData.append("other_product_info", otherProductInfo);
    formData.append("product_discount_percent", productDiscountPercentage);
    formData.append("description", productDescription);
    formData.append("tag", productTag);
    formData.append("is_weight_variable", isWeightVariable);
    formData.append("brand", productBrand);
    formData.append("benefits", productBenefits);
    formData.append("storage_and_usage", storageAndUsage);
    formData.append("product_type", productType);
    formData.append("product_slug", productSlug);
    formData.append("product_image", productImage);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_KEY}/product/update_product`,
        formData
      );
      return response.data;
      // console.log(categoryDetail);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const updateProductSlice = createSlice({
  name: "updateProducts",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(updateProduct.pending, (state) => {
      state.isLoading = true;
      state.updateProductStatus = "pending";
      // state.updateProductError = "";
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.isLoading = false;
      state.response = action.payload;
      state.updateProductStatus = "success";
      state.updateProductError = "";
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.isLoading = true;
      state.isError = true;
      state.updateProductStatus = "rejected";
      // state.updateProductError = action.payload;
      console.error(action.error);
    });
    builder.addCase(getProductDetails.pending, (state) => {
      state.isLoading = true;
      state.updateProductStatus = "pending";
      state.updateProductError = "";
    });
    builder.addCase(getProductDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.response = action.payload;
      state.updateProductStatus = "success";
      state.updateProductError = "";
      state.productDetails = action.payload.result;
    });
    builder.addCase(getProductDetails.rejected, (state, action) => {
      state.isLoading = true;
      state.isError = true;
      state.updateProductStatus = "rejected";

      // state.updateProductError = action.payload;
      console.error(action.error);
    });
  },
});

export const {
  viewUpdateProduct,
  openUpdateDeleteModal,
  closeUpdateModal,
  editUpdateProduct,
} = updateProductSlice.actions;
export default updateProductSlice.reducer;
